import { memo } from 'react';
import styled from '@emotion/styled';
import TextareaAutosize from '@mui/material/TextareaAutosize';

export const Textarea = memo(
  styled(TextareaAutosize)(({ theme }) => ({
    width: '100%',
    boxSizing: 'border-box',
    borderStyle: 'solid',
    borderWidth: '2px',
    borderRadius: '7px',
    padding: '8px',
    outline: 'none',
    resize: 'none',
    lineHeight: '22px',
    fontFamily: theme.fonts.regular,
    fontSize: '16px',
    appearance: 'none',
    borderColor: theme.palette.gray.light1,
    '&:focus': {
      borderColor: theme.palette.sentiment?.primary?.main ?? theme.palette.primary.main,
    },
  }))
);
